import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const EmojiSelector = ({ value, onChange, className = "" }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const emojis = [
    '👤', '👨', '👩', '🧑', '👱‍♂️', '👱‍♀️', 
    '👨‍💼', '👩‍💼', '👨‍🎤', '👩‍🎤', '👨‍🎨', '👩‍🎨',
    '👨‍💻', '👩‍💻', '👨‍🔬', '👩‍🔬', '👨‍🏫', '👩‍🏫',
    '🕺', '💃', '🎭', '🎪', '🎨', '🎵', '🎶', '🎸',
    '🎤', '🎬', '📻', '📺', '🎧', '🎙️', '📢', '📻',
    '🌟', '⭐', '✨', '🔥', '💫', '🎯', '🚀', '💎'
  ];

  const handleSelect = (emoji) => {
    onChange(emoji);
    setIsOpen(false);
  };

  return (
    <div className={`relative ${className}`}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-3 py-2 border border-gray-300 rounded-md bg-white hover:bg-gray-50 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      >
        <div className="flex items-center space-x-2">
          <span className="text-2xl">{value || '👤'}</span>
          <span className="text-sm text-gray-600">Sélectionner un avatar</span>
        </div>
        {isOpen ? (
          <ChevronUp size={16} className="text-gray-400" />
        ) : (
          <ChevronDown size={16} className="text-gray-400" />
        )}
      </button>

      {isOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto">
          <div className="grid grid-cols-8 gap-1 p-2">
            {emojis.map((emoji, index) => (
              <button
                key={index}
                type="button"
                onClick={() => handleSelect(emoji)}
                className={`w-8 h-8 flex items-center justify-center text-lg hover:bg-blue-100 rounded transition-colors ${
                  value === emoji ? 'bg-blue-100 ring-2 ring-blue-500' : ''
                }`}
              >
                {emoji}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default EmojiSelector; 